<svg
  class="transition-transform duration-200"
  [class.rotate-180]="expanded"
  width="10"
  height="6"
  viewBox="0 0 10 6"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">

  <path
    d="M0.644348 0.643555L4.50821 4.50742L8.37207 0.643555"
    stroke="currentColor"
    stroke-width="1.28795"
    stroke-linecap="round"
    stroke-linejoin="round"/>
</svg>
